import React from 'react'
import { Link } from "react-router-dom"
import { JsonLd } from "react-schemaorg"
import Image from "../components/Image"

interface PersonProps {
  link: string
  name: string
  image: string
  jobTitle?: string
  knowsAbout?: string[]
  alumniOf?: string[]
}

const Person: React.FC<PersonProps> = ({ 
  link, 
  name, 
  image, 
  jobTitle = "Lead Frontend Developer",
  knowsAbout = [
    "React",
    "Node.js",
    "Express.js",
    "MongoDB",
    "GraphQL",
    "Next.js",
    "JAMstack",
    "PWA",
    "SPA",
    "SSR",
    "SEO",
    "SASS",
    "LESS"
  ],
  alumniOf = ["Bournemouth University", "University of Worcester"]
}) => {
  return (
    <div className="mi-header-image">
      <Link to={link} title={name}>
        <Image src={image} alt={name} height="160" width="160" />
      </Link>
      <JsonLd
        item={{
          "@context": "https://schema.org",
          "@type": "Person",
          name,
          image,
          alumniOf: {
            "@type": "CollegeOrUniversity",
            name: alumniOf
          },
          knowsAbout,
          jobTitle
        }}
      />
    </div>
  )
}

export default Person
